export default __webpack_public_path__ + "static/media/profile.680ec59f.svg";